module.exports = __webpack_public_path__ + "img/zhongtianLogo.ffc55d3e.png";